import useModalMethod from '@/hooks/use-modal-method';
import { useEffect } from 'react';
import { triggerAddCustomerModal } from '../deep-mining/add-customer-modal';
import { getContactUsCustomerConfig3 } from '@/constants/tip-config';
import { useI18n } from '@/hooks/use-i18n';

const EVT_NAME = 'open-region-ban-modal';

export const openRegionBanModal = () => {
  window.dispatchEvent(new CustomEvent(EVT_NAME));
};

const RegionBanModal = () => {
  const modal = useModalMethod();
  const { t } = useI18n('components');
  const openModal = () => {
    const instance = modal.confirmTip({
      key: 'region-ban',
      title: t('regionBanModal.title'),
      content: t('regionBanModal.content'),
      okText: t('regionBanModal.okText'),
      cancelText: t('regionBanModal.cancelText'),
      cancelButtonProps: {
        className:
          '!h-10 !bg-[#7171EE1A] !text-[#7171ee] hover:!bg-[#7171EE1A] hover:!text-[#7171ee] !font-semibold !border-none !outline-none',
        onClick: (e) => {
          // 触发客服弹窗
          const config = getContactUsCustomerConfig3();
          triggerAddCustomerModal({
            title: config.title,
            data: config.data,
          });
          // 销毁弹窗
          instance.destroy();
        },
      },
    });
  };
  useEffect(() => {
    const handleOpenModal = () => {
      openModal();
    };
    window.addEventListener(EVT_NAME, handleOpenModal);
    return () => {
      window.removeEventListener(EVT_NAME, handleOpenModal);
    };
  }, []);
  return null;
};

export default RegionBanModal;
